import {
  AccountBallanceWalletIcon,
  DashboardIcon,
  DataUsageIcon,
  GoogleWifiIcon,
  HelpIcon,
  LogoutIcon,
  PackageManagementIcon,
  ProfileIcon,
} from "@dataone/icons";
import { Authority } from "@dataone/lib";

export interface ISiderMenu {
  key: string;
  label: string;
  icon?: JSX.Element;
  disabled?: boolean;
}

export type SiderMenuMap = {
  [key in Authority]: ISiderMenu[];
};

export const siderMenu: SiderMenuMap = {
  [Authority.OG_GUEST]: [
    {
      key: "profile",
      label: "Profile",
      icon: (
        <span style={{ fontSize: "18px" }}>
          <ProfileIcon />
        </span>
      ),
    },
    {
      key: "dashboard",
      label: "Dashboard",
      icon: (
        <span style={{ opacity: "0.3", fontSize: "19px" }}>
          <DashboardIcon />
        </span>
      ),
      disabled: true,
    },
    {
      key: "data-management",
      label: "Data center",
      icon: (
        <span style={{ opacity: "0.3", fontSize: "19px" }}>
          <GoogleWifiIcon />
        </span>
      ),
      disabled: true,
    },
    {
      key: "usage",
      label: "Usage",
      icon: (
        <span style={{ fontSize: "18px" }}>
          <DataUsageIcon />
        </span>
      ),
      disabled: true,
    },
    {
      key: "billing-methode",
      label: "Billing settings",
      icon: (
        <span style={{ fontSize: "18px" }}>
          <AccountBallanceWalletIcon />
        </span>
      ),
    },
  ],
  [Authority.OG_SUBSCRIBER]: [
    {
      key: "profile",
      label: "Profile",
      icon: (
        <span style={{ fontSize: "18px" }}>
          <ProfileIcon />
        </span>
      ),
    },
    {
      key: "dashboard",
      label: "Dashboard",
      icon: (
        <span style={{ fontSize: "19px" }}>
          <DashboardIcon />
        </span>
      ),
    },
    {
      key: "data-management",
      label: "Data center",
      icon: (
        <span style={{ fontSize: "19px" }}>
          <GoogleWifiIcon />
        </span>
      ),
    },
    {
      key: "usage",
      label: "Usage",
      icon: (
        <span style={{ fontSize: "18px" }}>
          <DataUsageIcon />
        </span>
      ),
    },
    {
      key: "billing-methode",
      label: "Billing settings",
      icon: (
        <span style={{ fontSize: "18px" }}>
          <AccountBallanceWalletIcon />
        </span>
      ),
    },
  ],
  [Authority.OG_SUBSCRIBER_EX]: [
    {
      key: "profile",
      label: "Profile",
      icon: (
        <span style={{ fontSize: "18px" }}>
          <ProfileIcon />
        </span>
      ),
    },
    {
      key: "dashboard",
      label: "Dashboard",
      icon: (
        <span style={{ fontSize: "19px" }}>
          <DashboardIcon />
        </span>
      ),
    },
    {
      key: "data-management",
      label: "Data center",
      icon: (
        <span style={{ fontSize: "19px" }}>
          <GoogleWifiIcon />
        </span>
      ),
    },
    {
      key: "usage",
      label: "Usage",
      icon: (
        <span style={{ fontSize: "18px" }}>
          <DataUsageIcon />
        </span>
      ),
    },
    {
      key: "billing-methode",
      label: "Billing settings",
      icon: (
        <span style={{ fontSize: "18px" }}>
          <AccountBallanceWalletIcon />
        </span>
      ),
    },
    // {
    //   key: "profile/preferences/subscription-settings",
    //   label: "Subscription settings",
    //   icon: (
    //     <span style={{ fontSize: "18px" }}>
    //       <CreditCardGearIcon />
    //     </span>
    //   ),
    // },
  ],
  [Authority.OG_ADMIN]: [
    {
      key: "profile",
      label: "Profile",
      icon: (
        <span style={{ fontSize: "16px", color: "#303030" }}>
          <ProfileIcon />
        </span>
      ),
    },
    {
      key: "dashboard",
      label: "Dashboard",
      icon: (
        <span style={{ fontSize: "19px" }}>
          <DashboardIcon />
        </span>
      ),
    },
    {
      key: "data-management",
      label: "Data center",
      icon: (
        <span style={{ fontSize: "19px" }}>
          <GoogleWifiIcon />
        </span>
      ),
    },
    {
      key: "package-management",
      label: "Package management",
      icon: (
        <span style={{ fontSize: "19px" }}>
          <PackageManagementIcon />
        </span>
      ),
    },
  ],
};

export const GuestActionsMenu: ISiderMenu[] = [
  {
    key: "support",
    label: "Help center",
    icon: (
      <span style={{ fontSize: "21px" }}>
        <HelpIcon />
      </span>
    ),
    disabled: true,
  },
  {
    key: "logout",
    label: "Logout",
    icon: (
      <span style={{ fontSize: "19px" }}>
        <LogoutIcon />
      </span>
    ),
  },
];

export const ActionsMenu: ISiderMenu[] = [
  {
    key: "support",
    label: "Help Center",
    icon: (
      <span style={{ fontSize: "21px" }}>
        <HelpIcon />
      </span>
    ),
  },
  {
    key: "logout",
    label: "Logout",
    icon: (
      <span style={{ fontSize: "19px" }}>
        <LogoutIcon />
      </span>
    ),
  },
];
